<template>
  <svg
    width="15"
    height="18"
    viewBox="0 0 15 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.0418 16.125L7.50016 12.1667L1.9585 16.125V3.45833C1.9585 3.03841
      2.12531 2.63568 2.42224 2.33875C2.71918 2.04181 3.1219 1.875 3.54183
      1.875H11.4585C11.8784 1.875 12.2811 2.04181 12.5781 2.33875C12.875 2.63568
      13.0418 3.03841 13.0418 3.45833V16.125Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>